// @ts-nocheck
import axios from 'axios';
import { BASE_URL } from '../../../../queries/useDataEngine';

export const ConstantAttributesService = {
  getConstantAttributeList: (params, loader = true) =>
    axios.get(BASE_URL + '/constants', { params, loader }),

  getConstantAttributeSchema: (params) =>
    axios.get(BASE_URL + '/constants/schema', { params }),

  getConstantAttributeSchemaPaginated: (params) =>
    axios.get(BASE_URL + '/constants/schema', {
      params: { ...params, page_size: 100 },
      loader: false,
    }),

  deleteConstantAttribute: (params) =>
    axios.delete(BASE_URL + '/constants', { params }),

  createConstantAttribute: (payload) =>
    axios.post(BASE_URL + '/constants', payload),

  getSingleConstantAttributeDetails: (params) =>
    axios.get(BASE_URL + '/constants', { params }),

  updateConstantAttribute: (payload) =>
    axios.put(BASE_URL + '/constants', payload),

  updateConstantAttributeExcelSchema: (payload) =>
    axios.put(BASE_URL + '/constants/excel/edit', payload),

  getExcelProcessingStatus: (params) =>
    axios.get(BASE_URL + '/constants/excel/progress-status', {
      params,
      loader: false,
    }),

  getConstantAttributeVersions: (params) =>
    axios.get(BASE_URL + '/constants/excel/versions', { params }),

  rollbackConstantAttributeVersion: (payload) =>
    axios.post(BASE_URL + '/constants/excel/rollback', payload),
};
